import React from 'react';
import { Flex, Form, Input, Button } from 'antd';
import { CheckIcon } from '@heroicons/react/20/solid';
import { motion, AnimatePresence } from 'framer-motion';

const { TextArea } = Input;

export const ExternalDepositConfirmation: React.FC<{
  onClose: () => void;
  onConfirm: ({
    depositTransactionHash,
  }: {
    depositTransactionHash: string;
  }) => void;
}> = ({ onConfirm, onClose }) => {
  const [form] = Form.useForm();

  const handleSubmit = (values: { depositTransactionHash: string }) => {
    onConfirm({
      depositTransactionHash: values.depositTransactionHash,
    });
  };

  const animationProps = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.4 },
  };

  return (
    <div className="absolute left-0 top-0 z-30 p-6 pt-20 flex h-full w-full rounded-lg bg-slate-800">
      <AnimatePresence>
        <motion.div className="h-full w-full" key="content" {...animationProps}>
          <Form
            className="h-full w-full flex flex-col justify-between"
            requiredMark={false}
            form={form}
            onFinish={handleSubmit}>
            <Form.Item
              name="depositTransactionHash"
              layout="vertical"
              label="Deposit Transaction Hash"
              rules={[
                { required: true, message: 'Please input transaction hash' },
              ]}>
              <TextArea
                rows={6}
                placeholder="Enter the transaction hash (0x...)"
              />
            </Form.Item>

            <Flex gap={'middle'}>
              <Button
                size="large"
                type="primary"
                onClick={onClose}
                className="w-[100%] bg-slate-700 hover:!bg-slate-600">
                Back
              </Button>

              <Button
                size="large"
                type="primary"
                htmlType="submit"
                className="bg-indigo-600 w-[100%] hover:!bg-indigo-500"
                icon={<CheckIcon className="w-4" />}>
                Confirm
              </Button>
            </Flex>
          </Form>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
